import Eventable from './eventable';
import { getLogger } from './logging/logger';

const logger = getLogger('LinkHandler');

export default class LinkHandler extends Eventable {
	/**
	 * @returns {RegExp}
	 */
	get linkPattern() {
		throw new Error('Pattern not implemented');
	}

	constructor() {
		super();
		logger.log('[constructor]');

		document.addEventListener('click', this.onLinkClick.bind(this));
	}

	/**
	 * Listens for click events on the DOM body and tests for a match against the handler pattern
	 * @param {MouseEvent} event DOMEvent for click event
	 */
	onLinkClick(event) {
		logger.log('[onLinkClick]', { event });

		const { target, type } = event;

		const isClick = type === 'click';
		const isAnchor = target instanceof HTMLAnchorElement;

		if (isClick && isAnchor) {
			const { href: url } = target;

			if (this.linkPattern.test(url)) {
				event.preventDefault();
				event.stopImmediatePropagation();
				this.handleLink(url);
			}
		}
	}

	/**
	 * Called when a link is clicked that matches the handlers pattern.
	 * @param {string} uri -The URI to handle
	 */
	async handleLink(uri) {
		logger.log(`[${this.handleLink.name}]`, { uri });

		throw new Error('Not implemented');
	}
}
